import { render, staticRenderFns } from "./CertificateHistorical.vue?vue&type=template&id=326fa487&scoped=true&"
import script from "./CertificateHistorical.vue?vue&type=script&lang=js&"
export * from "./CertificateHistorical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326fa487",
  null
  
)

export default component.exports